var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwoosh(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 198,
    height: 198,
    viewBox: "0 0 198 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size_12px",
    "data-name": "Size 12px",
    transform: "translate(-5360 -3682.256)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1394",
    "data-name": "Rectangle 1394",
    width: 198,
    height: 198,
    transform: "translate(5360 3682.256)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Logo_NIKE",
    d: "M155.891,421.181q-7.407-.294-12.137-4.057a24.254,24.254,0,0,1-2.521-2.523,15.755,15.755,0,0,1-2.733-4.918c-1.787-5.354-.867-12.379,2.631-20.09,3-6.6,7.618-13.148,15.683-22.216,1.188-1.334,4.726-5.236,4.749-5.236s-.184.334-.427.741a47.54,47.54,0,0,0-4.869,11.231c-1.57,5.747-1.381,10.679.555,14.5a14.167,14.167,0,0,0,6.2,6.178c4.506,2.208,11.1,2.39,19.159.535.555-.128,28.04-7.425,61.079-16.214s60.075-15.977,60.079-15.971-76.759,32.857-116.61,49.9c-6.311,2.7-8,3.38-10.966,4.422C168.176,420.129,161.383,421.4,155.891,421.181Z",
    transform: "translate(5242.082 3395.064)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwoosh);
export default __webpack_public_path__ + "static/media/swoosh.3aeff65fca5a04a5be228dd33499a2d9.svg";
export { ForwardRef as ReactComponent };